import useRouteName from "../../../hooks/useRouteName";
import { createTrackingUtils } from "..";
import { useSelector } from "react-redux";
import { getFlight } from "../../../store/flightDetails/selectors";
import { getExtraProducts } from "../../../ancillaries/store/extraProducts/selectors";
import { isVirtualInterliningFlight } from "../../../hooks/useVirutalInterlining";
import useProfiler from "../../../hooks/useProfiler";

const utils = createTrackingUtils({
  name: "flights_funnel_web_vi_checked_baggage",
  stages: {
    checked_baggage_vi_flight: 1,
    direct: 2,
    meta: 3,
    desktop: 4,
    mdot: 5,
    solo: 6,
    non_solo: 7
  },
  defaultStage: 1,
  goals: {},
  goalsWithValue: []
});

export const useTrackVICheckedBaggage = () => {
  const routeName = useRouteName();
  const flightDetails = useSelector(getFlight);
  const extraProducts = useSelector(getExtraProducts);
  const { isDirect, isMeta, isDesktop, isMobile, isSolo } = useProfiler();

  if (!flightDetails) return;

  if (routeName.includes("flightdetails")) {
    if (isVirtualInterliningFlight(flightDetails.segments) && flightDetails.ancillaries?.checkedInBaggage) {
      utils.trackWithDefaultStage();
      isDirect() && utils.stages.direct();
      isMeta() && utils.stages.meta();
      isDesktop() && utils.stages.desktop();
      isMobile() && utils.stages.mdot();
      isSolo() && utils.stages.solo();
      !isSolo() && utils.stages.non_solo();
    }

    return;
  }

  if (!extraProducts) return;

  if (isVirtualInterliningFlight(flightDetails.segments) && extraProducts.checkedInBaggage) {
    utils.trackWithDefaultStage();
    isDirect() && utils.stages.direct();
    isMeta() && utils.stages.meta();
    isDesktop() && utils.stages.desktop();
    isMobile() && utils.stages.mdot();
    isSolo() && utils.stages.solo();
    !isSolo() && utils.stages.non_solo();
  }
};

export default utils;
